import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { removeMedicationFromInquiryDraft } from '@api/inquiries';

export const handleRemoveMedicationFromInquiryDraft = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  { id: number }
>('removeMedicationFromInquiryDraft', ({ id }) => removeMedicationFromInquiryDraft(id));
